<h2>Unfortunately, this Flow cannot be found</h2>

<div inlineSVG="/assets/icons/ghost.svg"></div>

@if ((isUserLoggedIn$ | async)) {
  <p>
    You've tried to access a page that either does not exist or your account does not have access to view.
  </p>
  <p>
    You're currently signed in as @if (user$ | async; as user) {
    <strong>{{ user.email }}</strong>
    }.
  </p>
  <p>
    If you feel you've reached this in error, please reach out to <a href="mailto: support@flowinc.com">support&#64;flowinc.com</a>.
  </p>
  <fl-labeled-horizontal-separator label="or"></fl-labeled-horizontal-separator>
  <span>Click <a [routerLink]="['/dashboard']">here</a> to return home.</span>
} @else {
  <p>
    You've tried to access a page that either does not exist or requires you to login to access.
  </p>
  <p>
    If you feel you've reached this in error, please reach out to <a href="mailto: support@flowinc.com">support&#64;flowinc.com</a>.
  </p>
}

